import {
    AUTHENTICATED,
    AUTHENTICATING,
    AUTHEN_ERROR,
    LOGOUT
  } from "../actions/auth.action";
  
  const initialState = {
    isAuthenticated: false,
    user: {},
    loading: false
  };
  
  export default function(state = initialState, action) {
    switch (action.type) {
      case AUTHENTICATED:
        return {
          ...state,
          isAuthenticated: true,
          loading: false,
          user: action.payload
        };
        case AUTHENTICATING:
          return {
            ...state,
            loading: true
          };
        case AUTHEN_ERROR:
          return {
            ...state,
            error: action.payload
          };
        case LOGOUT:
          return {
            isAuthenticated: false,
            loading: false,
            user: null
          }
        default:
          return state
    }
  }